/** The data format of the response body: JSON or XML */
export enum ResponseFormat {
  JSON = 'json',
  XML = 'xml'
}
